export default "__VITE_ASSET__CYtq_UfT__"